// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"reset-password_3cpqy","security":"reset-password_21myy"};